import script from "./IAcquiringsButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IAcquiringsButton.vue?vue&type=script&setup=true&lang=js"

import "./IAcquiringsButton.vue?vue&type=style&index=0&id=7a4e3b60&lang=scss"

const __exports__ = script;

export default __exports__